import { AccountLockOpenIcon } from './AccountLockOpenIcon';

/**
 * author: Michael Irigoyen
 * id 255D3923-5FE0-4BDD-AAF4-D71735D52E53
 * name account-lock-open
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-lock-open.svg
 * tags
 * - Account / User 
 * - Lock 
 */
export const UserUnlockedIcon = AccountLockOpenIcon;
export default UserUnlockedIcon